import React, { createContext, useContext, useState, useCallback } from 'react';

const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [unsavedMessage, setUnsavedMessage] = useState('');
  const [unsavedPagePath, setUnsavedPagePath] = useState('');

  const setUnsaved = useCallback((hasChanges, message = '', pagePath = '') => {
    setHasUnsavedChanges(hasChanges);
    setUnsavedMessage(message);
    setUnsavedPagePath(pagePath);
  }, []);

  const clearUnsaved = useCallback(() => {
    setHasUnsavedChanges(false);
    setUnsavedMessage('');
    setUnsavedPagePath('');
  }, []);

  return (
    <UnsavedChangesContext.Provider value={{
      hasUnsavedChanges,
      unsavedMessage,
      unsavedPagePath,
      setUnsaved,
      clearUnsaved
    }}>
      {children}
    </UnsavedChangesContext.Provider>
  );
};

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    throw new Error('useUnsavedChanges must be used within UnsavedChangesProvider');
  }
  return context;
};
